import React from 'react';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import {DatabaseMetadataTableHeadProps} from './DatabaseMetadataTableComponentsProps';

function DatabaseMetadataTableHead(props: DatabaseMetadataTableHeadProps) {
   const {onSelectAllClick, numSelected, rowCount} = props;

   return (
      <>
         <colgroup>
            <col style={{width: '48px'}} />
            <col style={{width: '128px'}} />
            <col style={{width: '128px'}} />
            <col style={{width: 'auto'}} />
            <col style={{width: '128px'}} />
            <col style={{width: '120px'}} />
         </colgroup>
         <TableHead>
            <TableRow>
               <TableCell padding="checkbox">
                  <Checkbox
                     color="primary"
                     indeterminate={numSelected > 0 && numSelected < rowCount}
                     checked={rowCount > 0 && numSelected === rowCount}
                     onChange={onSelectAllClick}
                     inputProps={{
                        'aria-label': 'select all desserts'
                     }}
                  />
               </TableCell>
               <TableCell>Nombre BD</TableCell>
               <TableCell>Id Instancia</TableCell>
               <TableCell>Denominacion Instancia</TableCell>
               <TableCell align="right">Fecha Expiracion</TableCell>
               <TableCell align="center">Estado</TableCell>
            </TableRow>
         </TableHead>
      </>
   );
}

export default DatabaseMetadataTableHead;
